import {BaseDTO} from '../../../utils/base/dto';
import {ResearchSource} from './research-paper';

export enum ScreeningSettingsResearchDBTypes {
  LLM = "LLM",
  GENERATED = "GENERATED"
}

export interface ScreeningSettingsResearchDBDTO extends BaseDTO {
  source: ResearchSource;
  query: string;
  queryType: ScreeningSettingsResearchDBTypes;
  hidden: boolean;
  screeningSettingsId: number;
}

export interface ScreeningSettingsDTO extends BaseDTO {
  projectId: number;

  researchDBSettings: ScreeningSettingsResearchDBDTO[];

  enablePubMedQuery: boolean;
  enableScopusQuery: boolean;
  enableSemanticScholarQuery: boolean;

  enableYearFilter: boolean
  fromYear: number;
  toYear: number;

  maxResults: number;
}

export interface SimpleQueryDTO {
  query: string;
}

export enum ScreeningSettingsServiceTypes {
  SEMANTIC_SCHOLAR = "SEMANTIC_SCHOLAR",
  SCOPUS = "SCOPUS",
  PUBMED = "PUBMED",
  ALL = "ALL"
}

export interface ScreeningSettingsTestResearchResponseDTO {
  result: number;
}

export interface ScreeningSettingsTestResearchDTO {
  enableYearFilter: boolean
  fromYear?: number;
  toYear?: number;
  source: ResearchSource;
  query: string;
}
